module.exports = __webpack_public_path__ + "img/audience_estimate_gauge.7a174b3d.svg";